/**
 * Per-species base EXP yield. Cartridge Gen-3 values (Bulbapedia, FRLG
 * column). Mirrors data/baseHp.ts in spirit: hardcoded over dex-resolved
 * because (a) the table is small + synchronous, (b) the v0.1 species
 * roster is pinned in SPECIES_TO_DEX so a missing entry is a deploy-time
 * surprise we want to catch via throw.
 *
 * The trio Metapod/Kakuna/Sandshrew is included for fidelity completeness
 * even though those species are substituted out in trainer parties for v0.1
 * (no sprites). When sprites land, no extra work needed for EXP.
 */
const BASE_EXP: Record<string, number> = {
  bulbasaur: 64,
  charmander: 65,
  squirtle: 66,
  caterpie: 53,
  weedle: 52,
  pidgey: 55,
  rattata: 57,
  spearow: 58,
  pikachu: 82,
  geodude: 73,
  onix: 77,
  metapod: 71,
  kakuna: 71,
  sandshrew: 88,
};

/** Base EXP yield for a defeated Pokémon. Throws on unknown species —
 *  same defensive pattern as computeMaxHp. A typo in trainerParties.ts
 *  surfaces here on first KO rather than silently giving 0 EXP. */
export function getBaseExp(species: string): number {
  const v = BASE_EXP[species];
  if (v === undefined) {
    throw new Error(`getBaseExp: unknown species '${species}'. Add to data/baseExp.ts.`);
  }
  return v;
}
